"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Backbone_Icon_List = void 0;

var Kit_Detail = void 0;
var url_to_array = void 0;

Backbone_Icon_List = require("./backbone_iconlist").default;

url_to_array = require("../helpers/url_to_array").default;

Kit_Detail = function () {
    function Kit_Detail() {
        var $json = void 0;
        var author = void 0;
        var is_owner = void 0;
        var kit_name = void 0;
        var template = void 0;
        $json = (0, _jquery2.default)("#json");
        author = $json.data("author");
        is_owner = $json.data("is-owner");
        kit_name = $json.data("kitslug");
        if (is_owner === "True") {
            template = "html";
        } else {
            template = void 0;
        }
        new Backbone_Icon_List(".kit-detail-list ul", "//" + url_to_array[2] + "/json_kit_icons/user/" + author + "/kit/" + kit_name + "/", 2, template, 48, (0, _jquery2.default)("#footer"));
    }

    return Kit_Detail;
}();

exports.default = Kit_Detail;